import React from 'react'
import { compose, withHandlers, withStateHandlers } from 'recompose'
import IntroText from '../texts/intro-text'
import OptionGroup from '../forms/option-group'
import CtaButton from '../buttons/cta-button'
import { t } from '../../core/i18n'

const Home = props => (
  <div className='inner-wrapper'>
    <div className='top-space bottom-space'>
      <IntroText center>{t('home.title')}</IntroText>
    </div>
    <div className='bottom-space'>
      <IntroText center secondaryColor>
        What are you looking for?
      </IntroText>
    </div>
    <OptionGroup
      name='option'
      items={[
        {
          label: 'Fundraising events',
          checked: props.active === 'auctions',
          icon: 'fundrising-events',
          handleChange: props.changeToAuctions
        },
        {
          label: 'Great Auction items',
          checked: props.active === 'items',
          icon: 'auction-products',
          handleChange: props.changeToItems
        },
        {
          label: 'Charities',
          checked: props.active === 'charities',
          icon: 'charities',
          handleChange: props.changeToCharitites
        }
      ]}
    />
    <div className='action-block'>
      <CtaButton text='explore' onClick={props.goTo} />
    </div>
  </div>
)

const enhance = compose(
  withStateHandlers(() => ({ active: 'auctions' }), {
    changeActive: () => active => ({ active })
  }),
  withHandlers({
    goTo: ({ active, history }) => () => history.push(`/${active}`),
    changeToCharitites: ({ changeActive }) => () => changeActive('charities'),
    changeToAuctions: ({ changeActive }) => () => changeActive('auctions'),
    changeToItems: ({ changeActive }) => () => changeActive('items')
  })
)

export default enhance(Home)



// WEBPACK FOOTER //
// ./src/ui/views/home.js